import createDOMPurify from 'dompurify';

const DOMPurify = createDOMPurify(global.window);

export default DOMPurify;
